export const injectScript = (src: any) => {
  // Create script
  let script;
  script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.setAttribute('data-status', 'loading');
  // Add script to document body
  document.body.appendChild(script);

  return script;
};
